"use strict";Object.defineProperty(exports, "__esModule", {value: true});

// The Feedback dialog's chips. Each changes the dialog's title, prompt and
// placeholder; the server names the ticket and prefixes its message with the
// label. delete_account is not one: Settings' Delete account row files it.
 const SUPPORT_TICKET_TYPES = [
  {
    type: 'support',
    label: 'Support',
    title: 'How can we help?',
    prompt: 'Ask a question, share feedback or report a bug.',
    placeholder: 'Type your question…',
  },
  {
    type: 'feedback',
    label: 'Feedback',
    title: 'Share feedback',
    prompt: "Tell us what's working and what isn't.",
    placeholder: 'What would make BloomText better?',
  },
  {
    type: 'bug',
    label: 'Bug',
    title: 'Report a bug',
    prompt: "Tell us what went wrong and we'll look into it.",
    placeholder: 'What you did, what happened, and what you expected…',
  },
]; exports.SUPPORT_TICKET_TYPES = SUPPORT_TICKET_TYPES

 const SUPPORT_TICKET_AFTER_SEND = "You'll land in the chat after sending."; exports.SUPPORT_TICKET_AFTER_SEND = SUPPORT_TICKET_AFTER_SEND

 const SUPPORT_TICKET_SEND_FAILED = "Couldn't send your message. Please try again."; exports.SUPPORT_TICKET_SEND_FAILED = SUPPORT_TICKET_SEND_FAILED

// The fixed text of a staff delete_account ticket; the server appends the org
// name and whether the requester is an org admin.
 const DELETE_ACCOUNT_REQUEST_MESSAGE = 'Please delete my BloomText account.'; exports.DELETE_ACCOUNT_REQUEST_MESSAGE = DELETE_ACCOUNT_REQUEST_MESSAGE
